export const themes = {
    transparent: {
        default: {
            idle: ['text-primary', 'border-transparent'],
            hover: ['hover:bg-obsidian-600/40'],
            active: ['active:bg-obsidian-600/60'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-secondary', 'border-oxford-300'],
            hover: ['hover:border-obsidian-400'],
            active: ['active:border-obsidian-500'],
        },
    },
    transparentDark: {
        default: {
            idle: ['text-primary', 'border-transparent'],
            hover: ['hover:bg-white/20'],
            active: ['active:bg-white/50'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-primary', 'border-obsidian-900', 'border-opacity-20'],
            hover: ['hover:border-opacity-50'],
            active: ['active:border-opacity-100'],
        },
    },
    transparentLight: {
        default: {
            idle: ['text-secondary', 'border-transparent'],
            hover: ['hover:bg-black/20'],
            active: ['active:bg-black/50'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-secondary', 'border-white', 'border-opacity-20'],
            hover: ['hover:border-opacity-50'],
            active: ['active:border-opacity-100'],
        },
    },
    white: {
        default: {
            idle: ['bg-white', 'text-primary', 'border-white'],
            hover: ['hover:bg-obsidian-200', 'hover:border-obsidian-200'],
            active: ['active:bg-obsidian-400', 'active:border-obsidian-400'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-secondary', 'border-white'],
            hover: ['hover:text-obsidian-400', 'hover:border-obsidian-400'],
            active: ['active:text-obsidian-500', 'active:border-obsidian-500'],
        },
    },
    black: {
        default: {
            idle: ['bg-black', 'text-secondary', 'border-black'],
            hover: ['hover:bg-obsidian-700', 'hover:border-obsidian-700'],
            active: ['active:bg-obsidian-600', 'active:border-obsidian-600'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-primary', 'border-black'],
            hover: ['hover:text-obsidian-600', 'hover:border-obsidian-600'],
            active: ['active:text-obsidian-500', 'active:border-obsidian-500'],
        },
    },
    oxford: {
        default: {
            idle: ['bg-oxford-300', 'text-primary', 'border-oxford-300'],
            hover: ['hover:bg-oxford-400', 'hover:border-oxford-400'],
            active: ['active:bg-oxford-500', 'active:border-oxford-500'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-oxford-400', 'border-oxford-400'],
            hover: ['hover:text-oxford-500', 'hover:border-oxford-500'],
            active: ['active:text-oxford-600', 'active:border-oxford-600'],
        },
    },
    obsidian: {
        default: {
            idle: ['bg-obsidian-200', 'text-primary', 'border-obsidian-200'],
            hover: ['hover:bg-obsidian-400', 'hover:border-obsidian-400'],
            active: ['active:bg-obsidian-500', 'active:border-obsidian-500'],
        },
        outlined: {
            idle: ['text-obsidian-500', 'border-obsidian-500'],
            hover: ['hover:text-obsidian-600', 'hover:border-obsidian-600'],
            active: ['active:text-obsidian-700', 'active:border-obsidian-700'],
        },
    },
    kyber: {
        default: {
            idle: ['bg-kyber-400', 'text-primary', 'border-kyber-400'],
            hover: ['hover:bg-kyber-500', 'hover:border-kyber-500'],
            active: ['active:bg-kyber-600', 'active:border-kyber-600'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-kyber-400', 'border-kyber-400'],
            hover: ['hover:text-kyber-500', 'hover:border-kyber-500'],
            active: ['active:text-kyber-600', 'active:border-kyber-600'],
        },
    },
    kyberLight: {
        default: {
            idle: ['bg-kyber-200', 'text-primary', 'border-kyber-200'],
            hover: ['hover:bg-kyber-300', 'hover:border-kyber-300'],
            active: ['active:bg-kyber-400', 'active:border-kyber-400'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-kyber-200', 'border-kyber-200'],
            hover: ['hover:text-kyber-300', 'hover:border-kyber-300'],
            active: ['active:text-kyber-400', 'active:border-kyber-400'],
        },
    },
    primary: {
        default: {
            idle: ['bg-kyber-700', 'text-secondary', 'border-kyber-700'],
            hover: ['hover:bg-kyber-750', 'hover:border-kyber-750'],
            active: ['active:bg-kyber-950', 'active:border-kyber-950'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-kyber-700', 'border-kyber-700'],
            hover: ['hover:text-kyber-750', 'hover:border-kyber-750'],
            active: ['active:text-kyber-950', 'active:border-kyber-950'],
        },
    },
    custom: {
        default: {
            idle: ['bg-custom-primary', 'text-custom-secondary', 'border-custom-primary'],
            hover: ['hover:bg-custom-primary-hover', 'hover:border-custom-primary-hover'],
            active: ['active:bg-custom-primary-active', 'active:border-custom-primary-active'],
        },
        outlined: {
            idle: ['bg-transparent', 'text-custom-primary', 'border-custom-primary'],
            hover: ['hover:text-custom-primary-hover', 'hover:border-custom-primary'],
            active: ['active:text-custom-primary-active', 'active:border-custom-primary-active'],
        },
    },
};
//# sourceMappingURL=themes.js.map